import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy, RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
// import { HttpModule } from "@angular/http";
import {  HttpClientModule,  HttpClientXsrfModule,  HTTP_INTERCEPTORS,} from "@angular/common/http";
import { APP_BASE_HREF, LocationStrategy, PathLocationStrategy,HashLocationStrategy } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';

//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from "./app.component";
import { SidebarModule } from "./sidebar/sidebar.module";
import { FixedPluginModule } from "./shared/fixedplugin/fixedplugin.module";
import { FooterModule } from "./shared/footer/footer.module";
import { NavbarModule } from "./shared/navbar/navbar.module";
import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";
import { AppRoutingModule } from "./app.routing";
import { AtencionModule } from "./atencion/atencion.module";
import { PlaneacionModule } from "./planeacion/planeacion.module";
import { OperacionModule } from "./operacion/operacion.module";
import { IngresosModule } from "./ingresos/ingresos.module";
import { ComecializacionModule } from "./comercializacion/comercializacion.module";
import { FiscalizacionModule } from "./fiscalizacion/fiscalizacion.module";
import { AdministracionModule } from "./administracion/administracion.module";
import { SeguridadModule } from "./seguridad/seguridad.module";
import { UtileriasModule } from "./shared/utilerias/utilerias.module";
import { MedicionyfacturacionModule } from './medicionyfacturacion/medicionyfacturacion.module';
import { OlvidopassModule } from './componentes/olvidopass/olvidopass.module';
import { TooltipModule } from 'primeng/tooltip';

// used to create fake backend
// import { fakeBackendProvider } from "./_helpers";

import { JwtInterceptor, ErrorInterceptor } from "./_helpers";
import { CustomRouteReuseStrategy } from './_helpers/custom-route-reuse-strategy';

import { HomeComponent } from "./home";
import { LoginComponent } from "./login";
 import { OlvidopassComponent } from './componentes/olvidopass/olvidopass.component'; 
// import { VisorComponent } from "./componentes/visor/visor.component";
import { ComponentesModule } from "./componentes/componentes.module";
import { LOCALE_ID } from "@angular/core";
import { registerLocaleData } from "@angular/common";
//import localEs from "@angular/common/locales/es";
import localeEsMx from '@angular/common/locales/es-MX';
import localeEs from '@angular/common/locales/es';
import { from } from "rxjs";
import { BnNgIdleService } from 'bn-ng-idle';
import { MedidoresMedicionComponent } from './componentes/medidores-medicion/medidores-medicion.component'; // import bn-ng-idle service
registerLocaleData(localeEsMx);
registerLocaleData(localeEs, 'es');
@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    SliderModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    SidebarModule,
    NavbarModule,
    FooterModule,
    FixedPluginModule,
    AtencionModule,
    PlaneacionModule,
    OperacionModule,
    IngresosModule,
    ComecializacionModule,
    FiscalizacionModule,
    AdministracionModule,
    SeguridadModule,
    UtileriasModule,
    ComponentesModule,
    MedicionyfacturacionModule,
    OlvidopassModule,
    TooltipModule,
    MultiSelectModule,
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    HomeComponent,
    LoginComponent,
    OlvidopassComponent,
    MedidoresMedicionComponent
  
    // VisorComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: LOCALE_ID,
      useValue: "es-MX",
    },
    { provide: LOCALE_ID, useValue: 'es' },
    [BnNgIdleService],
    // {
    //   provide: LOCALE_ID,
    //   useValue: 'MXN',
    // },
    { provide: LocationStrategy, useClass: HashLocationStrategy  },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
   
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
